{
  "code": "en",
  "name": "English",
  "flag": "🇺🇸"
}
